import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';

import { useRoute, useRouter } from '@router';
import { useStore, useCommit } from '@store';
import { delay } from '@tools/delay';
import { isNumber } from '@tools/type-guards';

import DisplayTextCurrency from '@components/Display/DisplayTextCurrency.vue';

import { faShoppingCart } from '@icons/regular/faShoppingCart';
import { faTimes } from '@icons/solid/faTimes';
import { faTrashCan } from '@icons/solid/faTrashCan';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartWidget',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const showCartWidget = ref(false);
const newItemAdded = ref(false);

const cart = computed(() => store.state.cart);

const removeItem = useCommit('cart/REMOVE_ITEM');

watch(
  () => cart.value.items,
  async (newValue, oldValue) => {
    const newItemCount = newValue.length;
    const oldItemCount = oldValue?.length ?? newItemCount;

    // ...
    const wasHidden = !showCartWidget.value;

    // showCartWidget.value = !!newItemCount;
    showCartWidget.value = !!newItemCount;

    if (wasHidden || newItemCount < oldItemCount) return;

    newItemAdded.value = true;

    await delay(200);

    newItemAdded.value = false;
  },
);

const cartLength = computed(() => {
  return cart.value.items?.length;
});

/** ... */
const showCartButton = computed(() => {
  return (
    !route.value.name?.includes('dashboard') &&
    !showCartWidget.value &&
    !!cartLength.value
  );
});

/** ... */
const showBadge = computed(() => {
  return isNumber(cartLength.value) && cartLength.value > 0;
});

/**
 * Remove the product from the shopping cart.
 *
 * @param itemId ID of the item to remove from the cart.
 */
function removeFromCart(itemId: string) {
  removeItem({ itemId });
}

function goToCheckout() {
  void router.push({ name: 'preCheckout' });
}

return { __sfc: true,store, route, router, showCartWidget, newItemAdded, cart, removeItem, cartLength, showCartButton, showBadge, removeFromCart, goToCheckout, DisplayTextCurrency, faShoppingCart, faTimes, faTrashCan }
}

})